<header>
    <div class="left">
        <button (click)="sidebarEmit('left')" *ngIf="!offMenuIcons" class="open_menu"></button>
        <a *ngIf="member" class="logo company_title" href="/">
            {{ member.project_setting.project.name }}
        </a>
    </div>

    <ng-content></ng-content>

    <div class="right_block align-items-center">
        <div #notification class="notification_list">
            <div (click)="switchNotify()" class="login-menu">
                <i class="bi bi-bell sdm_style_text"></i>
                <span class="badge text-bg-info">{{ toastService.newNotification }}</span>
            </div>
            <div *ngIf="openNotify" [@fade]="'in'" class="submenu notification">
                <button (click)="toastService.notification = []; toastService.newNotification = 0"
                        *ngIf="toastService.notification.length"
                        class="btn btn-link">{{ 'MODALS.BUTTONS.CLEAR_LIST' | translate }}
                </button>
                <div *ngIf="toastService.notification.length">
                    <div (click)="toast.onClick(); switchNotify()" *ngFor="let toast of toastService.notification"
                         [class.new]="toast.isNew"
                         [innerHTML]="toast.textOrTpl"
                         class="notification_badge"
                         data-action='openProfile'></div>
                </div>
                <strong *ngIf="!toastService.notification.length"
                        class="notification_empty">{{ 'EMPTY_LISTS.NOTIFY' | translate }}</strong>
            </div>
        </div>
        <div #menu class="profile" data-action='openProfileMenu'>
            <div (click)="openProfile = !openProfile" class="login-menu">
                <i class="bi bi-person-circle sdm_style_text"></i>
                <span class="hello sdm_style_text"><ng-container
                        *ngIf="member">{{ helper.shortFullName(member) }}</ng-container>
                </span>
            </div>

            <div *ngIf="openProfile && member" [@fade]="'in'" class="submenu">
                <label>{{ member.firstname }}</label>
                <a [routerLink]="['/', 'account', 'options', 'profile']" class="profile_btn"
                   data-action='openProfile'>{{ 'PROFILE' | translate }}</a>
                <a (click)="logout();" class="logout_btn" data-action='logout'>{{ 'EXIT' | translate }}</a>
            </div>
        </div>
        <span (click)="sidebarEmit('right')" *ngIf="type === 'twoSidebars' && !offMenuIcons" class="mobile_more">
            <i class="icon-more"></i>
        </span>
    </div>
</header>
